import HeaderStyle1 from '../../components/HeaderStyle1';
import { Formik } from 'formik';
import * as Yup from 'yup';
import MailVector from '../../image/icons/MailVector.svg';
import LockVector from '../../image/icons/LockVector.svg';
import AuthServices from '../../services/AuthServices';
import { useHistory } from 'react-router';
import { useEffect } from 'react';
import { useMain } from '../../store/StoredContext';

// Creating schema
const schema = Yup.object().shape({
  email: Yup.string().required("L'e-mail est un champ obligatoire").email("Format d'email invalide"),
  password: Yup.string().required('Mot de passe est un champ obligatoire').min(3, "Mot de passe doit être d'au moins 3 caractères")
});

interface Response {
  message: string;
  status?: boolean;
  jwt: string;
}

function Login() {
  const history = useHistory();

  const { state: { token }, setToken } = useMain();

  useEffect(() => {
    function checkUser() {
      if (token != null && token !== undefined) {
        history.push('/');
      }
    }

    checkUser();
  }, [history, token]);

  return (
    <div className="h-full bg-ionic-secondary">
      <HeaderStyle1 height={'h-1/4'} />
      <div className="bg-ionic-white h-3/4 rounded-t-3xl overflow-y-auto">
        <div className="mt-16">
          <h1 className="text-ionic-secondary text-center font-bold text-3xl">Bienvenue</h1>
          <p className="text-ionic-gray text-center text-sm mt-1">{"S'identifier pour continuer"}</p>
        </div>
        <div className="mt-16 w-full p-0 flex justify-center">
          <div className="w-3/4">
            <Formik
              validationSchema={schema}
              initialValues={{ email: '', password: '' }}
              onSubmit={async (values) => {
                const response: Response = (await AuthServices.login(values)).data;
                if (response.status === false) {
                  alert(response.message);
                } else {
                  setToken(response.jwt);
                }
              }}
            >
              {({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
                <div className="login">
                  <div className="form">
                    <form noValidate onSubmit={handleSubmit}>
                      {/* Email */}
                      <div className="mb-5">
                        <div className="flex align-middle rounded-xl p-3 border-[#DCDCDC] border">
                          <div className="w-8 flex justify-center">
                            <img src={MailVector} width={28} />
                          </div>
                          <input
                            type="email"
                            name="email"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.email}
                            placeholder="Email"
                            id="email"
                            className="bg-transparent ml-4 text-ionic-tertiary outline-none text-sm w-full border-none"
                          />
                        </div>
                        {/* Errors if not valide */}
                        <p className="text-ionic-danger p-0 m-0 mt-1 text-xs">{errors.email != null && touched.email != null && errors.email}</p>
                      </div>
                      {/* Password */}
                      <div className="mb-5">
                        <div className="flex align-middle rounded-xl p-3 border-[#DCDCDC] border">
                          <div className="w-8 flex justify-center">
                            <img src={LockVector} width={16} />
                          </div>
                          <input
                            type="password"
                            name="password"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.password}
                            placeholder="Mot de passe"
                            className="bg-transparent ml-4 text-ionic-tertiary outline-none text-sm w-full border-none"
                          />
                        </div>
                        {/* Errors if not valide */}
                        <p className="text-ionic-danger p-0 m-0 mt-1 text-xs">{errors.password != null && touched.password != null && errors.password}</p>
                      </div>
                      <div className="mb-5">
                        <p className="text-ionic-primary text-sm">Mot de passe oublié ?</p>
                      </div>
                      <button type="submit" className="bg-ionic-primary w-full rounded-lg flex justify-center uppercase p-2">
                        Connexion
                      </button>
                      <div className="mt-10 text-center">
                        <p className="text-ionic-gray text-sm">{"Vous n'avez pas de compte ?"}</p>
                        <p className="text-ionic-primary text-sm">Créez un nouveau compte</p>
                      </div>
                    </form>
                  </div>
                </div>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
